import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { mappingResultError, Result } from '@digibricks/core';
import { FORM_CATEGORY_REPOSITORY } from '../../core';
import { FORM_CATEGORY_API, FORM_CATEGORY_WEB_CACHED } from '../data-sources';
export var FormCategoryWebRepository = /*#__PURE__*/function () {
  function FormCategoryWebRepository(formCategoryApi, formCategoryCached) {
    _classCallCheck(this, FormCategoryWebRepository);

    this.formCategoryApi = formCategoryApi;
    this.formCategoryCached = formCategoryCached;
  }

  _createClass(FormCategoryWebRepository, [{
    key: "findMany",
    value: function () {
      var _findMany = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
        var shouldPublishToGlobalForm, mode, cachedFormCategories, responseOrError, formCategoryResponses;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                shouldPublishToGlobalForm = query.shouldPublishToGlobalForm;
                mode = shouldPublishToGlobalForm === undefined ? 'all' : shouldPublishToGlobalForm ? 'global' : 'creation';
                _context.next = 4;
                return this.formCategoryCached.getFormCategories(mode);

              case 4:
                cachedFormCategories = _context.sent;

                if (!(cachedFormCategories.length > 0)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", Result.ok(cachedFormCategories));

              case 7:
                _context.next = 9;
                return this.formCategoryApi.search(query);

              case 9:
                responseOrError = _context.sent;

                if (!responseOrError.isFailure) {
                  _context.next = 12;
                  break;
                }

                return _context.abrupt("return", mappingResultError(responseOrError));

              case 12:
                formCategoryResponses = responseOrError.getValue();
                _context.next = 15;
                return this.formCategoryCached.saveFormCategories(formCategoryResponses, mode);

              case 15:
                return _context.abrupt("return", Result.ok(formCategoryResponses));

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function findMany(_x) {
        return _findMany.apply(this, arguments);
      }

      return findMany;
    }()
  }, {
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(input) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.formCategoryApi.create(input);

              case 2:
                responseOrError = _context2.sent;

                if (!responseOrError.isFailure) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", mappingResultError(responseOrError));

              case 5:
                return _context2.abrupt("return", Result.ok(responseOrError.getValue()));

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function create(_x2) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(useCaseInput) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.formCategoryApi.update(useCaseInput);

              case 2:
                responseOrError = _context3.sent;

                if (!responseOrError.isFailure) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return", mappingResultError(responseOrError));

              case 5:
                return _context3.abrupt("return", Result.ok());

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function update(_x3) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(id) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.formCategoryApi["delete"](id);

              case 2:
                responseOrError = _context4.sent;

                if (!responseOrError.isFailure) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt("return", mappingResultError(responseOrError));

              case 5:
                return _context4.abrupt("return", Result.ok());

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function _delete(_x4) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }]);

  return FormCategoryWebRepository;
}();
export var formCategoryWebRepositoryProvider = {
  provide: FORM_CATEGORY_REPOSITORY,
  useFactory: function useFactory(formCategoryApi, formCategoryCached) {
    return new FormCategoryWebRepository(formCategoryApi, formCategoryCached);
  },
  inject: [FORM_CATEGORY_API, FORM_CATEGORY_WEB_CACHED]
};